module.exports = __webpack_public_path__ + "static/logo_light-f82995e4e4c4897cc388e284b1577d0e.png";